/* global Element */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
import "svgxuse/svgxuse";
// Enable React dev tools
import React from "react";
import ReactDom from "react-dom";
import { addLocaleData, IntlProvider } from "react-intl";
import { Provider, connect } from "react-redux";
import App from "./containers/App";
import Store from "./store";
import { fetchCBook, fetchSearchable, logDebugMessage, setCurrentSlide, nextSlide, prevSlide } from "./actions";
import findIndex from "lodash/findIndex";
import isEqual from "lodash/isEqual";
import debounce from "lodash/debounce";
import { isSlideAvailable, getSlideIndex } from "./utils/helpers";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";
import de from "react-intl/locale-data/de";
import tr from "react-intl/locale-data/tr";
import hu from "react-intl/locale-data/hu";
import el from "react-intl/locale-data/el";
import pl from "react-intl/locale-data/pl";
import sv from "react-intl/locale-data/sv";
import sk from "react-intl/locale-data/sk";
import cs from "react-intl/locale-data/cs";
import sr from "react-intl/locale-data/sr";
import da from "react-intl/locale-data/da";
import it from "react-intl/locale-data/it";
import es from "react-intl/locale-data/es";
import ja from "react-intl/locale-data/ja";
import nl from "react-intl/locale-data/nl";
import pt from "react-intl/locale-data/pt";
import ru from "react-intl/locale-data/ru";
import zh from "react-intl/locale-data/zh";
import ko from "react-intl/locale-data/ko";
// Enabling tracking:
import "./utils/piwik";
import "../css/system.less";
window.cBOOK_VERSION = "6.15.7" || "not tagged";
if ("serviceWorker" in navigator) {
// navigator.serviceWorker.register('./sw.js')
}
addLocaleData(_toConsumableArray(cs).concat(_toConsumableArray(sr), _toConsumableArray(da), _toConsumableArray(de), _toConsumableArray(el), _toConsumableArray(en), _toConsumableArray(fr), _toConsumableArray(hu), _toConsumableArray(pl), _toConsumableArray(sk), _toConsumableArray(sv), _toConsumableArray(tr), _toConsumableArray(it), _toConsumableArray(es), _toConsumableArray(ja), _toConsumableArray(nl), _toConsumableArray(pt), _toConsumableArray(ru), _toConsumableArray(zh), _toConsumableArray(ko)));
// Object.values polyfill
if (!Object.values) {
    Object.values = function(o) {
        return Object.keys(o).map(function(k) {
            return o[k];
        });
    };
}
// console.error = (function (_error) {
//   return function (message) {
//     if (
//       typeof message !== 'string' ||
//       message.indexOf('component is `contentEditable`') === -1
//     ) {
//       if (_error) {
//         _error.apply(console, arguments);
//       }
//     }
//   };
// })(console.error);
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _$el = this;
        do {
            if (_$el.matches(s)) return _$el;
            _$el = _$el.parentElement || _$el.parentNode;
        }while (_$el !== null && _$el.nodeType === 1);
        return null;
    };
}
var httpsSupport = window.location.protocol === "https:";
Store.dispatch(logDebugMessage({
    message: httpsSupport ? "Available" : "Not available!",
    messageType: httpsSupport ? "info" : "error",
    label: "HTTPS"
}));
window.missingIntlMsgs = new Set();
var handleMissingIntlMsg = function(rawMsg) {
    if (process.env.NODE_ENV === "development") {
        var matches = rawMsg.match(/\"[a-zA-Z._-]+\"/g);
        if (matches.length === 0) return;
        var messageId = matches[0].replaceAll('"', "");
        window.missingIntlMsgs.add(messageId);
    // console.error(rawMsg);
    }
};
var runApp = function() {
    Store.dispatch(fetchCBook());
    var AppWithIntl = connect(function(state) {
        return {
            locale: state.intl.locale,
            formats: state.intl.formats,
            messages: state.intl.messages
        };
    })(function(param) {
        var locale = param.locale, formats = param.formats, messages = param.messages;
        return /*#__PURE__*/ React.createElement(IntlProvider, {
            key: locale,
            locale: locale,
            messages: messages,
            formats: formats,
            onError: handleMissingIntlMsg
        }, /*#__PURE__*/ React.createElement(App, null));
    });
    ReactDom.render(/*#__PURE__*/ React.createElement(Provider, {
        store: Store
    }, /*#__PURE__*/ React.createElement(AppWithIntl, null)), document.getElementById("cbook-root"));
    Store.dispatch(fetchSearchable());
};
if (!global.Intl) {
    import("intl").then(runApp);
} else {
    runApp();
}
// API for review
var getSavedIdIfExists = function(id, nodes) {
    return nodes.map(function(n) {
        return n.id;
    }).indexOf(id) > -1 ? id : nodes[0].id;
};
window.checkCurrentSlide = function() {
    var state = Store.getState();
    if (state.api) {
        var currentSlideId = getSavedIdIfExists(state.api.getCurrentSlide(), state.nodes.filter(function(n) {
            return n.target_type !== "Filter";
        }));
        if (currentSlideId !== state.currentSlide) {
            Store.dispatch(setCurrentSlide({
                id: currentSlideId
            }));
        }
    }
};
window.getSlideName = function(id) {
    var state = Store.getState();
    if (typeof id === "string") {
        id = parseInt(id, 10);
    }
    return (state.nodes.find(function(n) {
        return n.id === id;
    }) || {}).name || "";
};
window.getSlidePosition = function(id) {
    var state = Store.getState();
    if (typeof id === "string") {
        id = parseInt(id, 10);
    }
    var index = findIndex(state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    }), {
        id: id
    });
    return index > -1 ? index + 1 : 1;
};
window.navNext = function() {
    Store.dispatch(nextSlide());
};
window.navPrev = function() {
    Store.dispatch(prevSlide());
};
window.isSlideAvailable = function(s) {
    var _state_exam;
    var state = Store.getState();
    var interactions = state.exam ? state.examInteractions[(_state_exam = state.exam) === null || _state_exam === void 0 ? void 0 : _state_exam.id] : [];
    if (state.exam && state.exam.state === "running" && state.exam.position < interactions.length - 1) {
        var node = interactions[state.exam.position];
        return node ? isSlideAvailable(node, state) : false;
    } else {
        var slides = state.nodes.filter(function(n) {
            return n.target_type !== "Filter";
        });
        var index = getSlideIndex(state.currentSlide, state);
        switch(s){
            case "next":
                return isSlideAvailable(slides[index + 1], state);
            case "prev":
                return index > 0 ? isSlideAvailable(slides[index - 1], state) : false;
            default:
                return isNaN(s) ? false : isSlideAvailable(slides.find(function(_s) {
                    return _s.id === parseInt(s, 10);
                }), state);
        }
    }
};
window.getTotalSlides = function() {
    var state = Store.getState();
    return state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    }).length;
};
var dfn;
window.onSlideChange = function(fn) {
    dfn = debounce(fn, 50);
    var oldState = Store.getState();
    Store.subscribe(function() {
        var state = Store.getState();
        if (!isEqual(oldState.currentSlide, state.currentSlide) || !isEqual(oldState.completed, state.completed)) {
            dfn(state.currentSlide);
        }
        oldState = state;
    });
};
window.getCBookMode = function() {
    var _Store_getState;
    return !window.disableLinear ? (_Store_getState = Store.getState()) === null || _Store_getState === void 0 ? void 0 : _Store_getState.cbook.mode : "free";
};
window.toggleLinear = function() {
    window.disableLinear = !window.disableLinear;
    // trigger slide update
    if (dfn) {
        dfn(Store.getState().currentSlide);
    }
};
// API for review end
var zoom = 1;
var step = 0.05;
var updateZoom = function(_z) {
    if (document.body) {
        document.body.style.zoom = _z;
        document.body.style.MozTransform = "scale(".concat(_z, ")");
        Store.dispatch(logDebugMessage({
            message: "Current zoom level is now ".concat(_z * 100, "%"),
            messageType: "info",
            label: "ZOOM"
        }));
    }
};
window.zoomIn = function() {
    zoom += step;
    updateZoom(zoom);
};
window.zoomOut = function() {
    zoom -= step;
    updateZoom(zoom);
};
window.zoomReset = function() {
    zoom = 1;
    updateZoom(zoom);
};
